import { Container } from "components/layout/Container";
import { Button } from "components/UI/Buttons/Button";
import s from "./TaxonomiesList.module.scss";
import cs from "@/styles/modules/card.module.scss";
import cn from "classnames";

export type TaxonomiesListItem = {
  url: string;
  heading: string;
};

type TaxonomiesListProps = {
  heading: string;
  list: TaxonomiesListItem[];
};

export const TaxonomiesList = ({ list, heading }: TaxonomiesListProps) => {
  return (
    <div className={s.main}>
      <div className={cn(cs.h4, s.heading)}>{heading}</div>
      <div className={s.list}>
        <div className={s.listInner}>
          {list.map(({ url, heading }) => (
            <Button size="tiny" type="white" outline key={url} href={url} className={s.badge}>
              {heading}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};
